import { pusherChild } from '.';
import { CHANNEL_DASHBOARD } from './types';
export function subscribeToDashboard(event, callback) {
    return pusherChild.subscribe(CHANNEL_DASHBOARD).bind(event, callback);
}
